<template>
    <u-header-search-btn v-bind="$attrs" class="header-search--light">
        <slot />
    </u-header-search-btn>
</template>

<script>
import UHeaderSearchBtn from "@/components/publish/styles/headers/u-header-search-btn.vue";

export default {
    props: {},
    components: {
        UHeaderSearchBtn,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
